<script setup lang="ts">
import type { ISubmitData } from '@/pages/forLaywers/model/types/signupSection';
import { CALLBACK_FORM_NAME } from '@/shared/constants/callbackFormConstants';
import LandingCallback from '@/features/LandingCallback/index';
import SuccessBlock from '@/features/SuccessBlock/index';
import { useErrorHandler } from '@/shared/lib/errors';
import { SIGNUP_PHONE_INVALID_ERROR } from '@/pages/forLaywers/lib/signupConstants';

const { $callbackService } = useNuxtApp();
const isMobile: boolean = useIsMobile();
const { handleError } = useErrorHandler();
const success: Ref<boolean> = ref(false);
const isSubmitting: Ref<boolean> = ref(false);
const phoneError: Ref<string> = ref('');

const submitHandler = async (data: ISubmitData): Promise<void> => {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  phoneError.value = '';
  try {
    if (data.name && data.phone) {
      data.from = CALLBACK_FORM_NAME;
      await $callbackService.callback(data);
      success.value = true;
    }
  } catch (e) {
    const appError = handleError(e);
    if (appError.kind === 'validation') phoneError.value = SIGNUP_PHONE_INVALID_ERROR;
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <section
    :class="['signup', { _mobile: isMobile }, { _success: success }]"
    data-testid="signup-section"
  >
    <div class="signup__form-wrapper">
      <LandingCallback
        v-if="!success"
        v-model:phone-error="phoneError"
        :is-mobile="isMobile"
        :is-submitting="isSubmitting"
        @submit="submitHandler"
      />
      <SuccessBlock v-else is-horizontal-form />
    </div>
  </section>
</template>

<style lang="less">
.signup {
  .container-d();

  padding-top: 120px;
  padding-bottom: 120px;

  &__form-wrapper {
    background-color: @color-elephant;
    border-radius: @main-size;
    padding: @size-x8 80px;
  }

  &._success &__form-wrapper {
    padding: @size-x8 80px;
  }

  &._mobile {
    .container-m();

    padding-top: 48px;
    padding-bottom: 96px;
  }

  &._mobile &__form-wrapper {
    padding: @size-x8;
  }

  &._mobile._success &__form-wrapper {
    padding: @size-x8;
  }
}
</style>
